import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	logo: {
		"& img": {
			display: "block"
		}
	},
	logoBackground: {
		alignSelf: "flex-start",
		"& a": {
			background: theme.palette.common.white,
			borderRadius: "0 0 4px 4px",
			boxShadow: "0px 4.40299px 8.80597px rgba(0, 0, 0, 0.12)",
			display: "block",
			padding: theme.spacing(3, 1),
			[theme.breakpoints.up(360)]: {
				padding: theme.spacing(3, 2)
			},
			[theme.breakpoints.up("md")]: {
				padding: theme.spacing(3)
			},
			[theme.breakpoints.down(360)]: {
				"& img": {
					height: "auto",
					width: 100
				}
			}
		}
	}
}));

export default styles;
